import { LoginForm } from 'domains/auth/LoginForm';
import { PageContainer } from '@expressable/syntax-ds';

export const Login: React.FC = () => {
  return (
    <>
      <PageContainer variant="small-form" className="mt-[0px] mb-[0px]">
        <LoginForm />
      </PageContainer>
    </>
  );
};
